module.exports = __webpack_public_path__ + "static/media/imgg.1d7900fc.jpg";